/**
 * 抽壳特征预览执行器。
 */

import type { WorkerManager } from '../../../../worker';
import type { ShellFeatureDefinitionModel } from '../../../definition/shell/ShellFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import { FeaturePreviewExecution } from '../FeaturePreviewExecution';

/**
 * 抽壳特征预览执行器。
 */
export class ShellPreviewExecution extends FeaturePreviewExecution<ShellFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(definition: ShellFeatureDefinitionModel): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateShellPreview(definition.getCommandParams());
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<ShellFeatureDefinitionModel>,
        definition: ShellFeatureDefinitionModel,
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateShellPreviewInSandbox({
            commands: session.getPreviewCommands(),
            params: definition.getCommandParams(),
        });
    }
}
